import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import * as _4 from 'lodash4';

export interface ICRNSearchModel {
  sectionIds: number[];
  unPlannedCourseIds: number[];
  totalMatchCount: 0;
}

export type CRNSearchModel = ITypedModel<ICRNSearchModel>;
angular.module('capability-ng-scheduler').factory(
  'ngCRNSearchModel',
  () =>
    new Model<ICRNSearchModel>({
      sectionIds: [],
      unPlannedCourseIds: [],
      totalMatchCount: 0
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/crn_search/models/crn_search_model.ts